export const NOT_AVAILABLE = -1;
export const UNKNOWN = 0;
export const AVAILABLE = 1;
export const DENIED = 2;